<script lang="ts">
import Avatar from '@/components/Avatar.vue';

export default {
    name: 'SegmentsPlayerCard',
    components: {
        Avatar,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        // Marks the player who throws next (first in the upcoming row).
        isNext: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<template>
    <div class="grid grid-cols-[auto_1fr] gap-3">
        <Avatar
            :src="player?.avatar || player?.avatar_url"
            :size="11"
        />
        <div class="flex flex-col justify-center gap-1 overflow-hidden">
            <span class="font-semibold text-white line-clamp-1 overflow-ellipsis text-sm">{{ player?.tag_name }}</span>
            <div v-if="isActive" class="text-xs text-green-600 uppercase font-bold flex items-center gap-1 leading-3"> <div class="w-1.5 h-1.5 mb-1 rounded-2xl bg-green-600"></div>{{ $t('segments_game.throwing') }}</div>
            <div v-else-if="isNext" class="text-xs text-zinc-400 uppercase font-bold flex items-center gap-1 leading-3"> <div class="w-1.5 h-1.5 mb-1 rounded-2xl bg-zinc-400"></div>{{ $t('general.next') }}</div>
        </div>
    </div>
</template>